export default __webpack_public_path__ + "static/media/B_06_01_bg.97f3f1d2.mp4";